module.exports = __webpack_public_path__ + "img/diao_guan_ji0.fe4ef54e.png";